module.exports = __webpack_public_path__ + "img/title.079bf04b.png";